<script lang="ts">
  function onLogin() {
    window.location.href = '/auth/google_oauth2'
  }
</script>

<button class={$$props.class ?? ''} disabled={$$props.disabled}
        type="button"
        onclick={onLogin}>
  <slot/>
</button>
